$(document).ready(function () {
  //제품 정보 주입
  const productData = {
    boosterPro: {
      id: "boosterPro",
      name: "Booster Pro",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_booster_bk.png?v=1768198626",
            width: "100px",
          },
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_booster_pk.png?v=1768198626",
            width: "100px",
          },
        ],
        colors: ["#000000", "#FFCDCD"],
        link: "/products/age-r-booster-pro",
      },
      specs: {
        Mode: ["Booster Mode", "Derma Shot Mode", "MC Mode", "Air Shot Mode"],
        Weight: ["154g"],
        "How it works": ["Electroporation", "EMS", "Microcurrent", "Electric-needle"],
        Benefits: [
          "Boosts overall skin radiance and glow",
          "Helps with volumizing the forehead, smile lines, and under-eye area",
          "Care for overall facial contours",
          "Minimizes enlarged pores",
          "Cares for skin elasticity and firmness",
        ],
        "Accessory Compatibility": [],
        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
        "App Connectivity": [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/supported.png?v=1768200362",
        ],
      },
    },
    boosterMini: {
      id: "boosterMini",
      name: "Mini Booster Pro",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_mini_pk.png?v=1768199524",
            width: "100px",
          },
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_mini_wh.png?v=1768199524",
            width: "100px",
          },
        ],
        colors: ["#FFCDCD", "#EFEFEF"],
        link: "/products/mini-booster-pro",
      },
      specs: {
        Mode: [
          { main: "Red Mode", sub: "After Spot Care" },
          { main: "Blue Mode", sub: "Instant glow and calming effect" },
        ],
        Weight: ["75g"],
        "How it works": ["Electroporation "],
        Benefits: [
          "Boosts overall skin radiance and glow",
          "Increases both surface and deep hydration",
          "Helps achieve more even and brighter-looking skin",
        ],
        "Accessory Compatibility": [],
        Bluetooth: [],
        "App Connectivity": [],
      },
    },
    ultratune: {
      id: "ultratune",
      name: "Ultra Tune 40.68",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_tune.png?v=1768198626",
            width: "100px",
          },
        ],
        colors: ["#EFEFEF"],
        link: "/products/age-r-ultra-tune-40-68",
      },
      specs: {
        Mode: [],
        Weight: ["320g"],
        "How it works": ["RF", "Microcurrent"],
        Benefits: [
          "Cares for skin elasticity and firmness",
          "Helps with volumizing the forehead, smile lines, and under-eye area",
          "Care for overall facial contours",
        ],
        "Accessory Compatibility": [],
        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
        "App Connectivity": [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/supported.png?v=1768200362",
        ],
      },
    },
    airShot: {
      id: "airshot",
      name: "ATS Air Shot",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/airshot2.png?v=1768267842",
            width: "100px",
          },
        ],
        colors: ["#EFEFEF"],
        link: "/collections/age-r/products/age-r-ats-air-shot",
      },
      specs: {
        Mode: [],
        Weight: ["75g"],
        "How it works": ["Electric-needle"],
        Benefits: ["Minimizes enlarged pores", "Boosts overall skin radiance and glow"],
        "Accessory Compatibility": [],
        Bluetooth: [],
        "App Connectivity": [],
      },
    },
    lineShot: {
      id: "lineShot",
      name: "Line Shot",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/line_shot_img.jpg?v=1776737136",
            width: "100px",
          },
        ],
        colors: ["#EFEFEF"],
        link: "/products/age-r-line-shot",
      },
      specs: {
        Mode: [
          { main: "Shot Mode" },
          { main: "Booster Mode" },
        ],
        Weight: ["120g"],
        "How it works": ["Electroporation", "Electric-needle"],
        Benefits: ["Helps with volumizing the forehead, smile lines, and under-eye area", "Cares for skin elasticity and firmness"],
        "Accessory Compatibility": [],
        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
        "App Connectivity": [],
      },
    },
  };

 
  function applyResponsiveCompareUI() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    const thirdSelect = $(".product_select").eq(2);
    const thirdLine = $(".compare_line").eq(2);

    if (isMobile) {
      thirdLine.hide();
      thirdSelect.prop("disabled", true).hide();
    } else {
      thirdLine.show();
      thirdSelect.prop("disabled", false).show();
    }
  }

  function saveState() {
    const stateToSave = [];
    $(".product_select").each(function (index) {
      const $sel = $(this);
      if ($sel.is(":disabled") || !$sel.is(":visible")) return;

      const productId = $sel.val();
      const activeIndex = $(".compare_line").eq(index).data("activeIndex") || 0;
      stateToSave.push({ id: productId, activeIndex: activeIndex });
    });

    sessionStorage.setItem("productCompareState", JSON.stringify(stateToSave));
  }


  function updateAllDisplays() {
    $(".compare_line").each(function (index) {
      const $sel = $(".product_select").eq(index);

      if ($sel.is(":disabled") || !$sel.is(":visible")) {
        $(".product_info").eq(index).html("");
        return;
      }

      const productId = $sel.val();
      if (!productData[productId]) return;

      const product = productData[productId];
      updateProductInfo(product, index);
    });
    updateAllSpecs();
  }

  
  function updateProductInfo(product, index) {
    const productInfoContainer = $(".product_info").eq(index);
    const productColumn = $(".compare_line").eq(index);

    const activeIndex = productColumn.data("activeIndex") || 0;

    const imagesHtml = product.info.images
      .map((imageObject, i) => {
        const widthStyle = imageObject.width ? `style="width:${imageObject.width};"` : "";
        const activeClass = i === activeIndex ? "on" : "";
        return `<img src="${imageObject.src}" class="${activeClass}" ${widthStyle} />`;
      })
      .join("");

    const colorsHtml = product.info.colors
      .map((color, i) => {
        const activeClass = i === activeIndex ? "on" : "";
        return `<i style="background-color:${color};" class="${activeClass}"></i>`;
      })
      .join("");

    const infoHtml = `
      <div class="thumb_image">${imagesHtml}</div>
      <div class="thumb_type">${colorsHtml}</div>
      ${product.info.link ? `<a href="${product.info.link}" class="more show">Learn more</a>` : ""}
    `;
    productInfoContainer.html(infoHtml);
  }


  function updateAllSpecs() {
    const specList = $(".spec_list .spec");
    specList.html("");

    const selectedProductIds = $(".product_select")
      .filter(":visible:not(:disabled)")
      .map(function () {
        return $(this).val();
      })
      .get();

    specList.each(function () {
      const specGroup = $(this);
      const specTitle = specGroup.prev(".spec_sub_title").text();
      let maxSpecCount = 0;

      $.each(selectedProductIds, function (_, id) {
        const product = productData[id];
        if (product) {
          const specLength = product.specs[specTitle] ? product.specs[specTitle].length : 0;
          if (specLength > maxSpecCount) maxSpecCount = specLength;
        }
      });

      if (maxSpecCount === 0) maxSpecCount = 1;

      $.each(selectedProductIds, function (_, id) {
        const product = productData[id];
        const specValues = product && product.specs[specTitle] ? product.specs[specTitle] : [];
        let specItemsHtml = "";

        for (let i = 0; i < maxSpecCount; i++) {
          const defaultValue = i === 0 ? "-" : "";
          const value = specValues[i] || defaultValue;

          if (typeof value === "string" && value.includes(".png")) {
            specItemsHtml += `<img src="${value}" alt="${specTitle}">`;
          } else if (typeof value === "object" && value !== null && value.main) {
            const subText = value.sub ? `<em class="spec_sub_text">${value.sub}</em>` : "";
            specItemsHtml += `<span>${value.main} ${subText}</span>`;
          } else {
            specItemsHtml += `<span>${value}</span>`;
          }
        }

        specGroup.append(`<div class="spec_cont">${specItemsHtml}</div>`);
      });
    });
  }
function ensureUniqueVisibleSelects() {
  const $sels = $(".product_select").filter(":visible:not(:disabled)");
  const used = new Set();

  $sels.each(function () {
    const $sel = $(this);
    let val = $sel.val();

    if (used.has(val)) {
      // 중복이면 아직 안쓴 옵션으로 교체
      $sel.find("option").each(function () {
        const candidate = this.value;
        if (!used.has(candidate)) {
          $sel.val(candidate);
          val = candidate;
          return false; // break
        }
      });
    }

    used.add(val);
  });
}
  //초기화
  function initialize() {
    const savedStateJSON = sessionStorage.getItem("productCompareState");
    let savedState = null;

    if (savedStateJSON) {
      try {
        savedState = JSON.parse(savedStateJSON);
      } catch (e) {
        console.error("저장된 상태 파싱 실패:", e);
        sessionStorage.removeItem("productCompareState");
      }
    }

    const selects = $(".product_select");
    let optionsHtml = "";

    $.each(productData, function (id, product) {
      optionsHtml += `<option value="${id}">${product.name}</option>`;
    });
    selects.html(optionsHtml);

    
    applyResponsiveCompareUI();

    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (savedState && Array.isArray(savedState)) {

      if (savedState[0]) {
        selects.eq(0).val(savedState[0].id);
        $(".compare_line").eq(0).data("activeIndex", savedState[0].activeIndex || 0);
      }
      if (savedState[1]) {
        selects.eq(1).val(savedState[1].id);
        $(".compare_line").eq(1).data("activeIndex", savedState[1].activeIndex || 0);
      }
      if (!isMobile && savedState[2]) {
        selects.eq(2).val(savedState[2].id);
        $(".compare_line").eq(2).data("activeIndex", savedState[2].activeIndex || 0);
      }
    } else {
      // 기본값
      if (isMobile) {
        selects.eq(0).val("boosterMini");
        selects.eq(1).val("boosterPro");
      } else {
        selects.eq(0).val("boosterMini");
        selects.eq(1).val("boosterPro");
        selects.eq(2).val("airShot");
      }
    }
   ensureUniqueVisibleSelects();
    
    selects.each(function () {
      $(this).data("prevValue", $(this).val());
    });

    
    selects.on("change", function () {
      const currentSelect = $(this);

     
      if (currentSelect.is(":disabled") || !currentSelect.is(":visible")) return;

      const currentValue = currentSelect.val();
      const selectIndex = selects.index(currentSelect);

      let isDuplicate = false;

      selects
        .not(currentSelect)
        .filter(":visible:not(:disabled)")
        .each(function () {
          if ($(this).val() === currentValue) isDuplicate = true;
        });

     if (isDuplicate) {
        alert("This item is already selected.");

        const prev = currentSelect.data("prevValue");

      
        const hasPrev = prev && currentSelect.find(`option[value="${prev}"]`).length > 0;

        if (hasPrev) {
          currentSelect.val(prev);
        } else {
          
          currentSelect.prop("selectedIndex", 0);
          currentSelect.data("prevValue", currentSelect.val());
        }

        return;
      }

    
      $(".compare_line").eq(selectIndex).data("activeIndex", 0);

      currentSelect.data("prevValue", currentValue);

      updateAllDisplays();
      saveState();
    });

    $(".compare").delegate(".thumb_type i", "click", function () {
      const target = $(this);
      const productColumn = target.closest(".compare_line");
      const colIndex = $(".compare_line").index(productColumn);

      const relatedSelect = $(".product_select").eq(colIndex);
      if (relatedSelect.is(":disabled") || !relatedSelect.is(":visible")) return;

      const clickedIndex = target.index();
      productColumn.data("activeIndex", clickedIndex);

      target.addClass("on").siblings().removeClass("on");
      const productInfo = target.closest(".product_info");
      productInfo.find(".thumb_image img").removeClass("on").eq(clickedIndex).addClass("on");

      saveState();
    });

    updateAllDisplays();
  }

  initialize();

 
  $(window).on("resize", function () {
    applyResponsiveCompareUI();
    updateAllDisplays();
  });

  //scroll
  $(window).scroll(function () {
    const winScroll = $(this).scrollTop(),
      selectTop = $(".prd_compare_wrap .select_container").offset().top,
      selectWrap = $(".prd_compare_wrap .select_container .select_wrap"),
      headerHeight = $(".header-wrapper").innerHeight();

    if (winScroll >= selectTop - headerHeight) {
      selectWrap.addClass("fixed");
    } else {
      selectWrap.removeClass("fixed");
    }
  });
});